import { coreService } from '../service/core-service'
import { logger } from '../util/logger'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { queryKeys } from 'src/util/query-keys'

export const useLegalPrivacyPolicy = (): UseQueryResult<string, Error> => {
  return useQuery<string, Error>(queryKeys.legalPrivacyPolicy(), () => coreService.getLegalPrivacyPolicy(), {
    onError: (error) => {
      logger.error(error)
    },
  })
}

export const useLegalTermsAndConditions = (): UseQueryResult<string, Error> => {
  return useQuery<string, Error>(queryKeys.legalTermsAndConditions(), () => coreService.getLegalTermsAndConditions(), {
    onError: (error) => {
      logger.error(error)
    },
  })
}
